import { render, staticRenderFns } from "./DataSources.vue?vue&type=template&id=cffee3ce&scoped=true"
import script from "./DataSources.vue?vue&type=script&lang=js"
export * from "./DataSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffee3ce",
  null
  
)

export default component.exports